/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
module.exports = require("webpack-core/lib/RawSource");



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/RawSource.js
// module id = 4130
// module chunks = 0